import { Component, OnInit, Input } from '@angular/core';
import { Product } from './../../../models/product';
import { Attivazione } from '../../../models/attivazione';
import { AlgAttivazioniService } from './../../../services/alg-attivazioni.service';
import { takeUntil, withLatestFrom } from 'rxjs/operators';

import { Observable } from 'rxjs/Observable';
import { map, pluck } from 'rxjs/operators';

@Component({
  selector: 'alg-attivazioni-info-contract',
  templateUrl: './alg-attivazioni-info-contract.component.html',
  styleUrls: ['./alg-attivazioni-info-contract.component.scss'],
})
export class AlgAttivazioniInfoContractComponent {
  @Input() reverse: boolean;

  public productName$: Observable<string>;
  public isLight$: Observable<boolean>;
  public isGas$: Observable<boolean>;
  public lightRate$: Observable<string>;
  public duration$: Observable<string>;
  public isGreen$: Observable<boolean>;
  public promo$: Observable<string>;
  public attivazione: Attivazione;
  public productName: string = '';

  constructor(private consensoService: AlgAttivazioniService) {
    this.productName$ = this.consensoService.attivazioneProductName$;
    this.isLight$ = this.consensoService.attivazioneProduct$.pipe(
      map(
        (product) =>
          !!product &&
          (product.type === 'Luce' || product.type === 'Luce & Gas')
      )
    );
    this.isGas$ = this.consensoService.attivazioneProduct$.pipe(
      map(
        (product) =>
          !!product && (product.type === 'Gas' || product.type === 'Luce & Gas')
      )
    );
    this.lightRate$ = this.consensoService.attivazioneProduct$.pipe(
      map((product) => {
        if (Object.keys(product).length === 0 && product.constructor === Object)
          return null;
        if (!product || (!!product && product.type === 'Gas')) {
          return null;
        } else if (product.family.name === 'Seconda Casa') {
          return 'Monoraria';
        } else {
          return product.lightRate;
        }
      })
    );
    this.duration$ = this.consensoService.attivazioneProduct$.pipe(
      map((product) => {
        if (Object.keys(product).length === 0 && product.constructor === Object)
          return null;
        if (!product) {
          return null;
        } else if (product.family.name === 'Seconda Casa') {
          return '24 Mesi';
        } else if (product.duration === 'N/A') {
          return '';
        } else {
          return product.duration;
        }
      })
    );
    this.isGreen$ = this.consensoService.attivazione$.pipe(
      map((attivazione) => !!attivazione && attivazione.lightGreen)
    );
    this.promo$ = this.consensoService.attivazione$.pipe(
      map((attivazione) => !!attivazione && attivazione.promoCode)
    );
  }

  ngOnInit() {
    this.consensoService.attivazione$
      .subscribe((attivazione) => {
        if (!attivazione) {
          return;
        }
        this.attivazione = attivazione;
      });
    if (this.attivazione.product.lightRate) {
      this.productName = `${this.attivazione.product.family} ${this.attivazione.product.type} ${this.attivazione.product.lightRate}`
    } else {
      this.productName = `${this.attivazione.product.family} ${this.attivazione.product.type}`
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-info-contract/alg-attivazioni-info-contract.component.ts